import React from 'react'
import ProductsSectionTitle from '../ProductsSectionTitle'
import { Element } from 'react-scroll'

const AURAAgenticAIAction = () => {
  return (
    <>
      <Element
        name="AURAAgenticAIAction"
        className="datatalent-section-gap aaai-action bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "AURA Agentic AI in Action"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center">Powerful use cases where edge-deployed agents make a difference.</p>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card p-4 h-100 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/ruler.svg`} alt="ruler" />
                </div>
                <h5 className="mt-3 mb-3">On-Site Object Quantification</h5>
                <p className="mb-0">Edge-based vision models estimate object size, weight, or count for real-time insights in fields like agriculture, logistics, and manufacturing — all without needing to send data to the cloud.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/wrench.svg`} alt="wrench" />
                </div>
                <h5 className="mt-3 mb-3">Predictive Maintenance</h5>
                <p className="mb-0">Continuously analyze sensor inputs (vibration, thermal, acoustic) to detect equipment anomalies early and schedule proactive interventions.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/environment.svg`} alt="environment" />
                </div>
                <h5 className="mt-3 mb-3">Emission & Environmental Monitoring</h5>
                <p className="mb-0">Detect and log emissions, leaks, or environmental parameters directly at the source — even in remote or bandwidth-limited environments.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/clipboard.svg`} alt="clipboard" />
                </div>
                <h5 className="mt-3 mb-3">Real-Time Compliance Monitoring</h5>
                <p className="mb-0">Autonomous agents audit workflows, flag policy violations, and help maintain adherence to regulations without human oversight.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/gear.svg`} width="24px" alt="Gear" />
                </div>
                <h5 className="mt-3 mb-3">Process Optimization at the Edge</h5>
                <p className="mb-0">Monitor and dynamically adjust industrial or operational processes in real time to boost performance, quality, and energy efficiency.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card h-100 p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/satellite.svg`} width="24px" alt="satellite" />
                </div>
                <h5 className="mt-3 mb-3">Autonomous Asset Inspection</h5>
                <p className="mb-0">Use edge-deployed AI agents on drones or mobile platforms to inspect physical infrastructure (e.g., pipelines, solar panels, storage tanks) and report anomalies instantly — no connectivity required.</p>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AURAAgenticAIAction;